// extracted by mini-css-extract-plugin
export default {"container":"PostsCard_container__6UPVI","header":"PostsCard_header__zIZ3W","edit_modal":"PostsCard_edit_modal__jmxDd"};